import { SIDE_NAV_WIDTH } from './nav-items'

const colors = {
  background: '#0B1B2B',
  text: '#8C9AAE',
  textActive: '#FFFFFF',
  hover: 'rgba(255, 255, 255, 0.06)',
  active: 'rgba(255, 255, 255, 0.1)',
  brand: '#015FFB',
}

const styles = () => ({
  // Fixed, not sticky: the editor's global CSS sets `body { display: inline }`,
  // which breaks sticky positioning. The shell reserves the space instead.
  root: {
    position: 'fixed',
    top: 0,
    left: 0,
    bottom: 0,
    zIndex: 1100,
    width: SIDE_NAV_WIDTH,
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '4px',
    padding: '14px 0',
    backgroundColor: colors.background,
  },
  logo: {
    display: 'flex',
    flex: 'none',
    marginBottom: '14px',
  },
  logoImage: {
    width: 36,
    height: 36,
  },
  item: {
    position: 'relative',
    width: 64,
    flex: 'none',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '4px',
    padding: '8px 0',
    border: 0,
    borderRadius: '8px',
    background: 'transparent',
    cursor: 'pointer',
    color: colors.text,
    fontFamily: "'Inter', system-ui, sans-serif",
    textDecoration: 'none',
    transition: 'background-color 160ms ease, color 160ms ease',
    '&:hover': {
      color: colors.textActive,
      background: colors.hover,
    },
  },
  itemActive: {
    color: colors.textActive,
    background: colors.active,
    '& $label': {
      fontWeight: 600,
    },
  },
  icon: {
    width: 20,
    height: 20,
    flex: 'none',
  },
  label: {
    fontSize: '10px',
    fontWeight: 500,
    whiteSpace: 'nowrap',
  },
  newBadge: {
    position: 'absolute',
    top: -4,
    right: -2,
    padding: '1px 4px',
    borderRadius: '4px',
    fontSize: '8px',
    fontWeight: 700,
    letterSpacing: '0.04em',
    lineHeight: 1.3,
    color: '#FFFFFF',
    background: colors.brand,
  },
  footer: {
    marginTop: 'auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '8px',
  },
  avatar: {
    width: 32,
    height: 32,
    padding: 0,
    border: 0,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: colors.brand,
    color: '#FFFFFF',
    fontFamily: "'Inter', system-ui, sans-serif",
    fontSize: '11px',
    fontWeight: 600,
    textTransform: 'uppercase',
    cursor: 'pointer',
  },
  avatarOpen: {
    boxShadow: `0 0 0 2px ${colors.background}, 0 0 0 4px #FFFFFF`,
  },
})

export default styles
